import { createUseApiQuery } from 'hooks/useQuery/useApiQuery';
import { ApiName } from 'types/apiName';

export const usePlutoApiQuery = createUseApiQuery(ApiName.plutoApi);
